
import React, { lazy, Suspense } from 'react';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const Index = lazy(() => import('./index/index'));
const Purchase = lazy(() => import(/* webpackPrefetch: true */ './purchase/index'));

// chunk 加载失败时自动刷新，避免白屏
class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error) {
        // webpack chunk 加载失败（网络中断、部署更新等）
        if (error && (error.name === 'ChunkLoadError' || /Loading chunk/.test(error.message))) {
            // 避免无限刷新：5秒内只刷新一次
            const lastReload = sessionStorage.getItem('chunk_reload');
            if (!lastReload || Date.now() - Number(lastReload) > 5000) {
                sessionStorage.setItem('chunk_reload', String(Date.now()));
                window.location.reload();
            }
        }
    }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{background:'#0a0a0f',height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',color:'#a1a1aa',flexDirection:'column',gap:'16px'}}>
                    <div>页面加载出错</div>
                    <button onClick={() => window.location.reload()} style={{padding:'8px 24px',borderRadius:'8px',border:'1px solid rgba(255,255,255,0.12)',background:'#6366f1',color:'#fff',cursor:'pointer'}}>
                        点击刷新
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function LoadingScreen() {
    return (
        <div style={{
            background: '#0a0a0f',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '24px',
        }}>
            {/* 品牌光环动画 */}
            <div style={{ position: 'relative', width: 64, height: 64 }}>
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    border: '3px solid rgba(99,102,241,0.15)',
                }} />
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    border: '3px solid transparent',
                    borderTopColor: '#6366f1',
                    animation: 'spin 0.8s linear infinite',
                }} />
                <div style={{
                    position: 'absolute',
                    inset: '8px',
                    borderRadius: '50%',
                    border: '3px solid transparent',
                    borderTopColor: '#818cf8',
                    animation: 'spin 1.2s linear infinite reverse',
                }} />
                <div style={{
                    position: 'absolute',
                    inset: '18px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #6366f1, #818cf8)',
                    opacity: 0.9,
                    animation: 'pulse 1.5s ease-in-out infinite',
                }} />
            </div>
            <div style={{
                color: '#a1a1aa',
                fontSize: '14px',
                letterSpacing: '2px',
                animation: 'fadeIn 0.6s ease',
            }}>
                加载中
            </div>
            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes pulse { 0%,100% { opacity: 0.6; transform: scale(0.9); } 50% { opacity: 1; transform: scale(1); } }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}

function App() {
    return (
        <ChunkErrorBoundary>
            <BrowserRouter>
                <Suspense fallback={<LoadingScreen />}>
                    <Routes>
                        <Route path="/" element={<Index />} />
                        <Route path="/purchase" element={<Purchase />} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </ChunkErrorBoundary>
    );
}

export default App;
